<template>
    <div class="contents">
        <div class="container-fluid">
            <FollowUpNavigation />
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Template Pesan
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <router-link to="/follow-up/template/add" class="btn px-15 btn-primary text-white" style="display: inline-flex; margin: 5px">
                                <i class="fas fa-plus fs-16"></i>
                                Tambah Template
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <FollowUpTemplateTable ref="templateTable" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FollowUpTemplateTable from "@/components/tables/FollowUpTemplate.vue";
import FollowUpNavigation from "@/components/followup/Navigation.vue";

export default {
    components: {
        FollowUpTemplateTable,
        FollowUpNavigation
    },
    mounted() {
        this.$refs.templateTable.loadItems();
    }
};
</script>


